import type { FastifyPluginAsync } from 'fastify'
import { costTracker } from '../../services/cost-tracker.service.js'
import { createLogger } from '../../common/utils/logger.js'

const logger = createLogger('AnalyticsController')

export const analyticsRoutes: FastifyPluginAsync = async (fastify) => {
    /**
     * POST /analytics/track-cost
     * Track API usage cost from frontend (e.g. Mapbox, OSRM)
     */
    fastify.post('/track-cost', {
        schema: {
            body: {
                type: 'object',
                properties: {
                    provider: { type: 'string' },
                    service: { type: 'string' },
                    cost: { type: 'number' },
                    usage: { type: 'number' },
                    unit: { type: 'string' },
                    feature: { type: 'string' }
                },
                required: ['provider', 'service', 'cost', 'usage', 'unit']
            }
        }
    }, async (request, reply) => {
        try {
            const params = request.body as any
            const userId = request.user?.uid // From auth middleware if available

            await costTracker.track({
                ...params,
                userId
            })

            return reply.status(200).send({ success: true })
        } catch (error) {
            logger.error('Failed to track cost from frontend', { error })
            return reply.status(500).send({ success: false })
        }
    })
}
